function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
import React from "react";
import PropTypes from "prop-types";

const InfoFilled = _ref => {
  let {
    size = "1em",
    color = "currentColor",
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    style: {
      width: size,
      height: size
    },
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: title ? 'img' : 'presentation'
  }), title ? /*#__PURE__*/React.createElement("title", null, title) : null, " ", /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm.1-16.55c.752 0 1.336.547 1.336 1.282 0 .728-.585 1.273-1.336 1.273-.75 0-1.336-.545-1.336-1.273 0-.735.584-1.282 1.336-1.282zM11.014 9.5v8.884h2.172V9.5h-2.172z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, " "));
};

InfoFilled.propTypes = {
  /** The width/height of the icon as any CSS size unit */
  size: PropTypes.string,

  /** The fill color of the icon as any CSS color value */
  color: PropTypes.string,

  /** The title to add as a child of the root svg element */
  title: PropTypes.string
};
export default InfoFilled;